import type { CSSProperties } from 'react';

import styles from '@/app/[locale]/ai-model/ai-models.module.css';
import type { AiModel } from '@/libs/ai-models';

type ModelMarkModel = Pick<AiModel, 'shortName' | 'accent'>;

export default function ModelMark({ model, compact = false }: { model: ModelMarkModel; compact?: boolean }) {
  const letters = model.shortName
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <span
      className={`${styles.modelMark} ${compact ? styles.modelMarkCompact : ''}`}
      style={{ '--model-accent': model.accent } as CSSProperties}
      aria-hidden="true"
    >
      {letters}
    </span>
  );
}
